import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/@dashboard/MouseLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/@dashboard/TouchLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/devices/MouseDeviceOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/devices/TouchDeviceOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/GlobalDialog/GlobalDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActivePathProvider"] */ "/workspace/contexts/ActivePathContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CameraSettingsProvider"] */ "/workspace/contexts/CameraSettingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogProvider"] */ "/workspace/contexts/DialogContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/contexts/QueryClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SoundSettingsProvider"] */ "/workspace/contexts/SoundSettingsContext.tsx");
